import { Temporal } from '@js-temporal/polyfill';
import { CoordinatorService, MANIFEST_STORE_DELAY } from './coordinator.service';
import { Chapter } from './chapter';
import { Subject, debounceTime } from 'rxjs';
import { ScriptDocument } from './script-document';

export class Document {
    id: string;
    title: string;
    description: string;

    created: Temporal.ZonedDateTime;
    private _chapterLs: Chapter[] = [];

    private _currentItem?: Chapter;

    private _markForManifestStoreSubject$ = new Subject<void>();
    private _markForManifestStore$ = this._markForManifestStoreSubject$.pipe(
        debounceTime(MANIFEST_STORE_DELAY),
    );

    constructor(
        public coords: CoordinatorService,
        public params: any,
    ) {
        this.id = params.id || this.coords.uniqueId();
        this.title = params.title || this.coords.text('newNotepad');
        this.description = params.description || '';
        this.created = params.created
            ? Temporal.ZonedDateTime.from(params.created)
            : this.coords.utils$.zonedDateTimeNow;

        this._markForManifestStore$.subscribe(() => this._manifestStore());

        params.chapterLs?.forEach((x: any) => {
            const ch = new Chapter(this.coords, this, x);
            this._chapterLs.push(ch);
        });
    }

    get(id: string) {
        for (const itm of this._chapterLs) if (itm.id === id) return itm;
        return undefined;
    }

    markForManifestStore() {
        this._markForManifestStoreSubject$.next();
    }

    delete() {
        this.coords.notepad$.delete(this);
        this._manifestDelete();
        this.coords.display$.markForCheck();
    }

    private _manifestDelete() {
        const ls = [
            {
                id: this.id,
                type: 'notepad',
            },
        ];
        this.coords.manifest$.delete(ls);
    }

    get itemLs() {
        const ls = Array.from(this._chapterLs);
        if (!ls.length) {
            const item = this.addItem();
            item && ls.push(item);
        }
        return ls;
    }

    itemReadyLs = this.itemLs;

    addItem(chapter?: Chapter, isBefore = false): Chapter | undefined {
        if (!this.coords) {
            console.warn('Document - Skip adding item as coords is undefined', this.coords);
            return;
        }

        const itm = new Chapter(this.coords, this, {});
        if (chapter) {
            let i = this._chapterLs.indexOf(chapter);
            if (!isBefore) i++;
            this._chapterLs.splice(i, 0, itm);
        } else this._chapterLs.push(itm);
        this.coords.display$.markForCheck();
        this.markForManifestStore();
        return itm;
    }

    public get currentItem(): Chapter {
        if (!this._currentItem) {
            this._currentItem = this.itemLs[0];
        }
        return this._currentItem;
    }
    public set currentItem(value: Chapter) {
        this._currentItem = value;
        this.coords.display$.markForCheck();
    }

    activate() {
        this.coords.notepad$.current = this;
    }

    private _manifestStore() {
        this.coords.manifest$.store({
            type: 'notepad',
            id: this.id,
            valueMap: new Map<string, any>([
                ['isDocument', true],
                ['title', this.title],
                ['description', this.description],
                ['chapterLs', this._chapterLs.map((ch) => ch.save())],
            ]),
        });

        console.log('MANIFEST STORE', this._chapterLs);
    }

    get scriptClass() {
        return new ScriptDocument(this.coords, this);
    }
}
